/**
 * CSV Exporter
 * Export goal completion data to CSV format
 */

import { getAllAccounts, getGoalsByAccountId } from '../storage/GoalStorage';
import { replayCompletionEvents } from '../storage/CompletionLog';
import { formatDateToISO } from '../../utils/dateUtils';

/**
 * Export all completion data to CSV format
 * Format: date,goal_name,goal_type,completed,account_name
 */
export const exportToCSV = async (): Promise<string> => {
  const rows: string[] = [];

  // CSV Header
  rows.push('date,goal_name,goal_type,completed,account_name');

  // Get all accounts
  const accounts = await getAllAccounts();

  for (const account of accounts) {
    // Get all goals for this account
    const goals = await getGoalsByAccountId(account.id);

    for (const goal of goals) {
      // Get completions for this goal
      const completionMap = await replayCompletionEvents(account.id, goal.id);
      const completions = Array.from(completionMap.values());

      // Sort by date (most recent first)
      completions.sort((a, b) => b.date.localeCompare(a.date));

      // Add row for each completion
      for (const completion of completions) {
        const completed = completion.completed ? 'yes' : 'no';
        const row = [
          completion.date,
          `"${goal.name.replace(/"/g, '""')}"`,  // Escape quotes in goal name
          goal.type,
          completed,
          `"${account.name.replace(/"/g, '""')}"`,  // Escape quotes in account name
        ].join(',');

        rows.push(row);
      }
    }
  }

  return rows.join('\n');
};

/**
 * Generate CSV filename with current date
 */
export const generateCSVFilename = (): string => {
  const today = formatDateToISO(new Date());
  return `everydaygoal-export-${today}.csv`;
};
